import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllCompanies, GetCompanyByID, CreateNewCompany, UpdateCompany, UploadCompanyLogoSquare, UploadCompanyLogoWide } from "helpers/api_method";


export const getAllCompaniesList = createAsyncThunk("companies/getAllCompaniesList", async () => {
    try {
        const response = await GetAllCompanies();
        return response.data;
    } catch (error) {
        return error;
    }
});
export const getCompanyDetailsByID = createAsyncThunk("companies/getCompanyDetailsByID", async (event: any) => {
    try {
        const response = await GetCompanyByID(event);
        return response.data;
    } catch (error) {
        console.error("getCompanyDetailsByID error:", error);
        return error;
    }
});
export const addNewCompany = createAsyncThunk("companies/addNewCompany", async (event: any) => {
    try {
        const response = await CreateNewCompany(event);
        toast.success("Company created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Company creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateExistingCompany = createAsyncThunk("companies/updateExistingCompany", async (event: any) => {
    try {
        const response = await UpdateCompany(event.id, event);
        toast.success("Settings updated Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Settings updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const uploadCompanyLogoSquare = createAsyncThunk(
    "companies/uploadCompanyLogoSquare",
    async ({ companyId, formData }: { companyId: any; formData: FormData }, { rejectWithValue }) => {
        try {
            const response = await UploadCompanyLogoSquare(companyId, formData);
            toast.success("Square logo uploaded successfully", { autoClose: 2000 });
            return response.data;
        } catch (error) {
            console.error('Square logo upload error:', error);
            return rejectWithValue(error);
        }
    }
);

export const uploadCompanyLogoWide = createAsyncThunk(
    "companies/uploadCompanyLogoWide",
    async ({ companyId, formData }: { companyId: any; formData: FormData }, { rejectWithValue }) => {
        try {
            const response = await UploadCompanyLogoWide(companyId, formData);
            toast.success("Wide logo uploaded successfully", { autoClose: 2000 });
            return response.data;
        } catch (error) {
            console.error('Wide logo upload error:', error);
            return rejectWithValue(error);
        }
    }
);

